import { useStepValidation } from 'features/libra/StepValidationContext'

/**
 * Why AI pre-fill must not run right now, or null when it may. The agent
 * reads only persisted ticket data, so unsaved user or AI edits on the active
 * step would feed it old inputs. Unsaved system defaults do not block.
 */
export function usePrefillBlockedReason(): string | null {
  const { hasUnsavedEdits } = useStepValidation()
  return hasUnsavedEdits ? 'Save this step before pre-filling with AI' : null
}
